import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <div className="w-full">
        <input
          type={type}
          className={cn(
            // text-base (16px) em mobile evita o zoom automático que o iOS
            // dispara ao focar inputs com fonte menor; sm:text-sm volta ao
            // 14px clássico em telas maiores.
            "flex h-11 w-full rounded-xl border bg-white px-4 py-2 text-base sm:text-sm text-[#1F2937] transition-all",
            "placeholder:text-[#6B7280]",
            // Focus suave alinhado ao manifesto ILovePage: ring de 4px com
            // rose 10% — emocional sem peso visual.
            "focus:outline-none focus:border-[#E11D48] focus:shadow-[0_0_0_4px_rgba(225,29,72,0.10)]",
            "disabled:cursor-not-allowed disabled:opacity-50",
            error
              ? "border-red-400 focus:border-red-500 focus:shadow-[0_0_0_4px_rgba(239,68,68,0.10)]"
              : "border-[#FFE4E6] hover:border-[#FCA5A5]",
            className
          )}
          ref={ref}
          {...props}
        />
        {error && (
          <p className="mt-1 text-xs text-red-500">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
